import {
    BLOCKUNBLOCKSUBADMINLIST_SUCCESS,
    BLOCKUNBLOCKSUBADMINLIST_FAILED,
    RESET_BLOCKUNBLOCKSUBADMINLIST,
    LOADING_BLOCKUNBLOCKSUBADMINLIST,
    NETWORK_ERROR_BLOCKUNBLOCKSUBADMINLIST,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_BLOCKUNBLOCKSUBADMINLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case BLOCKUNBLOCKSUBADMINLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case BLOCKUNBLOCKSUBADMINLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_BLOCKUNBLOCKSUBADMINLIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_BLOCKUNBLOCKSUBADMINLIST:
            return (state = initialState);
        default:
            return state;
    }
};
